import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import { IUser } from './api.models';

@Injectable({providedIn: 'root'})
export class ApiService {

  private csrfToken: string | null = null;

  constructor(private http: HttpClient) {
    this.loadCsrfToken();
  }

  // Fetch CSRF token before making POST requests
  private loadCsrfToken() {
    this.http.get<{ csrfToken: string }>('api/csrf-token', { withCredentials: true }).subscribe({
      next: (data) => {
      this.csrfToken = data.csrfToken;
    },
    error: (err) => {
        console.error('Error loading CSRF token:', err);
      }
    });
  }

  private getCsrfTokenHeader(): HttpHeaders {
   let headers = new HttpHeaders();
    if (this.csrfToken) {
      headers = headers.set('x-csrf-token', this.csrfToken);
    }
    return headers;
  }

  getUsers(): Observable<IUser> {
    return this.http.get<IUser>('api/users');
  }

 generateReport({configuration}): Observable<Blob> {
    const headers = this.getCsrfTokenHeader()
      .set('Accept', 'application/pdf')
      .set('Content-Type', 'application/json');
    return this.http.post('api/reports', configuration, {
      headers: headers,
      responseType: 'blob',
      withCredentials: true});
  }

  generateLogotype({configuration}): Observable<string> {
    return this.http.post('api/logotypes', configuration, {
      headers: this.getCsrfTokenHeader(),
      responseType: 'text',
      withCredentials: true});
  }

  exportLogotype({configuration}):  Observable<any> {
    return this.http.post('api/exports', configuration, {
        headers: this.getCsrfTokenHeader(),
        observe: 'response',
        withCredentials: true});
  }

  generateDiploma({configuration}): Observable<Blob> {
      const headers = this.getCsrfTokenHeader()
        .set('Accept', 'application/pdf')
        .set('Content-Type', 'application/json');
      return this.http.post('api/diplomas', configuration, {
        headers: headers,
        responseType: 'blob',
        withCredentials: true});
  }
}
